<template>
  <div>
    <el-form-item label="默认值">
      <a href="https://avuejs.com/doc/plugins/map-plugins" target="_blank" style="color: #409eff;"
        >详细文档</a
      ><br />
      <el-input v-model="data.value" placeholder="默认值"></el-input>
    </el-form-item>
    <el-form-item label="是否禁用">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'config-map',
  props: ['data'],
  data() {
    return {
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null,
      },
    };
  },
  methods: {
    generateRule() {
      const rules = [];
      Object.keys(this.validator).forEach((key) => {
        if (this.validator[key]) rules.push(this.validator[key]);
      });
      this.data.rules = rules;
    },
  },
  watch: {
    "data.label": function (val) {
      if (val)
        this.validator.required = {
          required: true,
          message: `请输入${this.data.label}`,
        };
      else this.validator.required = null;
      this.generateRule();
    },
    'data.required': function (val) {
      if (val) this.validator.required = { required: true, message: `请输入${this.data.label}` };
      else this.validator.required = null;

      this.generateRule();
    },
  },
};
</script>
